import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import {
  ActionGetResourceDefinitionResponseModel,
  ActionsHttpServiceService,
  RequiredParamsForActionsHttpRequests,
} from 'src/app/services/httpServices/actionsHttpService/actions-http-service.service';
import { HttpErrorResponse } from '@angular/common/http';
import { HttpErrorHandlerService } from 'src/app/services/httpServices/httpErrorHandlerService/http-error-handler.service';
import { NotificationsService } from 'src/app/services/infra/notifications/notifications.service';
import { PopupPosition } from '../copy-button/copy-button.component';
import { ResourceType } from 'src/app/models/api';
import { LabelsProviderPipe } from 'src/app/pipes/labels-provider/labels-provider.pipe';
import { ActionGetRawResourceOutputs } from 'src/app/models/api/actions/getResourceDefinition.model';
import { ZenityEntityActionResultCode } from 'src/app/models/api/actions/zenityEntityActions';
import { Label } from 'src/app/labels/englishLabels';

@Component({
  selector: 'app-get-resource-definition-action',
  templateUrl: './get-resource-definition-action.component.html',
  styleUrls: ['./get-resource-definition-action.component.scss'],
})
export class GetResourceDefinitionActionComponent {
  public rawJson = '';
  public title = '';
  public description = '';
  public waitingForResponse = true;
  public failedToGetDefinition = false;
  public popupPosition = PopupPosition;

  constructor(
    private readonly _labelsProviderPipe: LabelsProviderPipe,
    public dialogRef: MatDialogRef<GetResourceDefinitionActionComponent>,
    @Inject(MAT_DIALOG_DATA)
    public actionsParams: RequiredParamsForActionsHttpRequests,
    private readonly _actionsHttpService: ActionsHttpServiceService,
    private readonly _httpErrorHandlerService: HttpErrorHandlerService,
    private readonly _notificationService: NotificationsService
  ) {
    if (actionsParams.resourceType === ResourceType.flow) {
      // Handling for the old actions API
      this._actionsHttpService.getFlowDefinition(actionsParams).subscribe({
        next: (response: ActionGetResourceDefinitionResponseModel) => {
          this.rawJson = JSON.stringify(response.rawJson, null, '\t');
          this.waitingForResponse = false;
          this.title = Label.get('commonActions.getFlowDefinitionAction.title');
          this.description = Label.get('commonActions.getFlowDefinitionAction.rawJsonDescription');
        },
        error: (httpError: HttpErrorResponse) => {
          this.waitingForResponse = true;
          if (this._httpErrorHandlerService.isUnhandledExceptionError(httpError.status)) {
            this._httpErrorHandlerService.handle(httpError);
          } else {
            this._notificationService.error(httpError.error.detail);
          }
          this.failedToGetDefinition = true;
          this.waitingForResponse = false;
        },
      });
    } else {
      // Handling for the new actions API
      this._actionsHttpService.getRawResource(actionsParams.integrationId, actionsParams.resourceId).subscribe({
        next: (response: ActionGetRawResourceOutputs) => {
          this.waitingForResponse = false;
          if (response.resultCode != ZenityEntityActionResultCode.success) {
            const message = `${response.title}. ${response.description ?? ''}`;
            this._notificationService.error(message);
            this.failedToGetDefinition = true;
          } else {
            this.rawJson = JSON.stringify(response.rawJson, null, '\t');
            this.title = Label.getRawResourceTextFromLabel(actionsParams.resourceType).title;
            this.description = Label.getRawResourceTextFromLabel(actionsParams.resourceType).rawJsonDescription;
          }
        },
        error: (httpError: HttpErrorResponse) => {
          this.waitingForResponse = true;
          if (this._httpErrorHandlerService.isUnhandledExceptionError(httpError.status)) {
            this._httpErrorHandlerService.handle(httpError);
          } else {
            this._notificationService.error(httpError.error.detail);
          }
          this.failedToGetDefinition = true;
          this.waitingForResponse = false;
        },
      });
    }
  }

  public closeWindow(): void {
    this.dialogRef.close();
  }
}
